import { createContext, useContext } from 'react'

import { Return } from 'modules/core/lib/asyncAction'

import type { AnalyticsFilterForm } from 'modules/surveys/hooks/useAnalyticsMultiFilters'
import type { AnalyticResults } from 'modules/surveys/store/collections/analyticResults'
import type { QuestionGroups } from 'modules/surveys/store/collections/questionGroups'
import type AnalyticResult from 'modules/surveys/store/models/AnalyticResult'
import type { Cycle } from 'modules/surveys/store/models/AnalyticResult'
import type SurveyForm from 'modules/surveys/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

export interface AnalyticsContextValues {
  canEditSurvey: boolean
  loading: boolean
  form: SurveyForm | Survey
  analyticResults: AnalyticResults
  analyticResult: AnalyticResult | undefined | null
  questionGroups: QuestionGroups
  cycle: Cycle | null
  setCycle: (cycle: Cycle) => void
  surveyAnalyticsFilter: AnalyticsFilterForm | undefined
  setSurveyAnalyticsFilter: (surveyAnalyticsFilter: AnalyticsFilterForm) => void
}

export const analyticsContext = createContext<AnalyticsContextValues | null>(null)

export const useAnalytics = () => {
  const context = useContext(analyticsContext)

  if (!context) {
    throw new Error('analyticsContext must be used within a SurveyAnalyticsProvider')
  }

  return context
}

interface ContextProps {
  form: SurveyForm | null | undefined
  survey: Survey | null | undefined
  hasSurveyV2: boolean
  canbeStarted: boolean
  isAnonymous: boolean
  updateCanBeStarted: () => Promise<Return<void>>
  canEditSurvey: boolean
  loading: boolean
  isClassicSurveyDisabled: boolean
}

export const SurveyShowContext = createContext<ContextProps | null>(null)

export const useSurveyShowContext = () => {
  const context = useContext(SurveyShowContext)

  if (!context) {
    throw new Error('SurveyShowContext must be within its provider')
  }

  return context
}
